import { request, spUrl } from "utils";
import moment from "moment";

import { HAPLO_COSTING_API } from "globals/constants";

const fetchData = id => {
	return request(spUrl(`${HAPLO_COSTING_API}/${id}`))
		.then(result => result.allItems.map(costing => {
			return {
				...costing,
				costingStartDate: costing.costingStartDate ? moment(costing.costingStartDate).format('YYYY-MM-DD') : null,
				costingLead: costing.costingLead.join()
			}
		}
	));
};

const Helper = {
	apiKey: "costingId",
	fetchData
}

export default Helper;